import { doGetCall } from "../config/rest";

export const FETCH_PARTNERLISTDATA_BEGIN = "FETCH_PARTNERLISTDATA_BEGIN";
export const FETCH_PARTNERLISTDATA_SUCCESS = "FETCH_PARTNERLISTDATA_SUCCESS";
export const FETCH_PARTNERLISTDATA_FAILURE = "FETCH_PARTNERLISTDATA_FAILURE";

export const fetchPartnerListDataBegin = () => ({
  type: FETCH_PARTNERLISTDATA_BEGIN,
});

export const fetchPartnerListDataSuccess = (PartnerListPageResponse, PartnerListPageComponents) => ({
  type: FETCH_PARTNERLISTDATA_SUCCESS,
  totalResponse: { PartnerListPageResponse },
  payload: { PartnerListPageComponents },
});

export const fetchPartnerListDataFailure = (error) => ({
  type: FETCH_PARTNERLISTDATA_FAILURE,
  payload: { error },
});

function getPartnerListPageComponents() {
  return doGetCall(`/wp-json/hybris/v1/partners?pageSize=9999`);
}

export function fetchPartnerListPageComponents() {
  return (dispatch) => getPartnerListPageComponents()
    .then((json) => {
      dispatch(fetchPartnerListDataSuccess(json["partners"]));
      return json;
    })
    .catch((error) => dispatch(fetchPartnerListDataFailure(error)));
}
